import { loginApiAxiosParams } from "api/axiosHookParams";
import API_ENDPOINTS from "api/endpoints";
import useUser from "context/User/useUser";
import { useAxios } from "hooks";
import { useCallback } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

const useLogin = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const navigate = useNavigate();
  const { callAxios: callLoginUserApi, loading } =
    useAxios(loginApiAxiosParams);

  const { onLoginUser } = useUser();

  const handleNavigation = (path) => () => {
    navigate(path);
  };

  const handleLoginUser = useCallback(
    async (data) => {
      const { email, password } = data;

      const result = await callLoginUserApi({
        url: API_ENDPOINTS.LOGIN(email, password),
      });

      if (result?.user_info) {
        onLoginUser(result?.user_info);
      }
    },
    [callLoginUserApi, onLoginUser]
  );

  const handleLoginFormSubmit = handleSubmit(handleLoginUser);

  return { handleNavigation, handleLoginFormSubmit, register, errors, loading };
};

export default useLogin;
